module.exports = __webpack_public_path__ + "static/media/Flourish.eb42c8cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/Flourish.svg
// module id = 6
// module chunks = 0